import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
        path: '/login',
        component: resolve => require(['@/page/login.vue'], resolve),
    }, {
        path: '/',
        component: resolve => require(['@/page/index.vue'], resolve),
        redirect: '/article/article_list',
        children: [{
            path: '/article/article_list',
            component: resolve => require(['@/page/article/article_list.vue'], resolve),
        },
        {
            path: '/article/add_article',
            component: resolve => require(['@/page/article/add_article.vue'], resolve),
        },
        {
            path: '/article/add_article',
            component: resolve => require(['@/page/article/add_article.vue'], resolve),
        },
        {
            path: '/team/add_team',
            component: resolve => require(['@/page/team/add_team.vue'], resolve),
        },
        {
            path: '/team/team_list',
            component: resolve => require(['@/page/team/team_list.vue'], resolve),
        },
        {
            path: '/investment/combination',
            component: resolve => require(['@/page/investment/combination.vue'], resolve),
        },
        {
            path: '/investment/add_combination',
            component: resolve => require(['@/page/investment/add_combination.vue'], resolve),
        },
        {
            path: '/investment/interview',
            component: resolve => require(['@/page/investment/interview.vue'], resolve),
        },
        {
            path: '/investment/add_interview',
            component: resolve => require(['@/page/investment/add_interview.vue'], resolve),
        },
        {
            path: '/business/report',
            component: resolve => require(['@/page/business/report.vue'], resolve),
        },
        {
            path: '/business/add_report',
            component: resolve => require(['@/page/business/add_report.vue'], resolve),
        },
        {
            path: '/business/team',
            component: resolve => require(['@/page/business/team.vue'], resolve),
        },
        {
            path: '/business/add_team',
            component: resolve => require(['@/page/business/add_team.vue'], resolve),
        },
        {
            path: '/business/project',
            component: resolve => require(['@/page/business/project.vue'], resolve),
        },
        {
            path: '/business/add_project',
            component: resolve => require(['@/page/business/add_project.vue'], resolve),
        },
          {
            path: '/business/news_list',
            component: resolve => require(['@/page/business/csNews/news_list.vue'], resolve),
          },
          {
            path: '/business/news_list_ja',
            component: resolve => require(['@/page/business/csNews/news_list_ja.vue'], resolve),
          },
          {
            path: '/business/add_news',
            component: resolve => require(['@/page/business/csNews/add_news.vue'], resolve),
          },
          {
            path: '/business/add_news_ja',
            component: resolve => require(['@/page/business/csNews/add_news_ja.vue'], resolve),
          },
        {
          path: '/business/add_banner',
          component: resolve => require(['@/page/business/banner/add.vue'], resolve),
        },
          {
            path: '/business/add_banner_ja',
            component: resolve => require(['@/page/business/banner/add_ja.vue'], resolve),
          },
        {
          path: '/business/banner_list',
          component: resolve => require(['@/page/business/banner/list.vue'], resolve),
        },
          {
            path: '/business/banner_list_ja',
            component: resolve => require(['@/page/business/banner/list_ja.vue'], resolve),
          },
        {
            path: '/business/practice',
            component: resolve => require(['@/page/business/practice.vue'], resolve),
        },
        {
            path: '/business/add_practice',
            component: resolve => require(['@/page/business/add_practice.vue'], resolve),
        },
        {
            path: '/business/administration',
            component: resolve => require(['@/page/business/administration.vue'], resolve),
        },
        {
            path: '/business/add_administration',
            component: resolve => require(['@/page/business/add_administration.vue'], resolve),
        },
        {
            path: '/business/idea',
            component: resolve => require(['@/page/business/idea.vue'], resolve),
        },
        {
            path: '/business/add_idea',
            component: resolve => require(['@/page/business/add_idea.vue'], resolve),
        },
        {
            path: '/tag/add_news',
            component: resolve => require(['@/page/tag/add_news.vue'], resolve),
        },
        {
            path: '/tag/news',
            component: resolve => require(['@/page/tag/news.vue'], resolve),
        },
        {
            path: '/content/home_page',
            component: resolve => require(['@/page/content/home_page.vue'], resolve),
        },
        {
            path: '/content/about',
            component: resolve => require(['@/page/content/about.vue'], resolve),
        },
        {
            path: '/content/society',
            component: resolve => require(['@/page/content/society.vue'], resolve),
        },
        {
            path: '/content/agreement',
            component: resolve => require(['@/page/content/agreement.vue'], resolve),
        },
        {
            path: '/content/clause',
            component: resolve => require(['@/page/content/clause.vue'], resolve),
        },
        {
            path: '/content/prize',
            component: resolve => require(['@/page/content/prize.vue'], resolve),
        },
        {
            path: '/content/add_prize',
            component: resolve => require(['@/page/content/add_prize.vue'], resolve),
        },
        {
            path: '/content/address',
            component: resolve => require(['@/page/content/address.vue'], resolve),
        },
        {
            path: '/content/add_address',
            component: resolve => require(['@/page/content/add_address.vue'], resolve),
        },
        {
            path: '/content/team_pic',
            component: resolve => require(['@/page/content/team_pic.vue'], resolve),
        },
        {
            path: '/content/add_team_pic',
            component: resolve => require(['@/page/content/add_team_pic.vue'], resolve),
        },
        {
            path: '/content/institute_pic',
            component: resolve => require(['@/page/content/institute_pic.vue'], resolve),
        },
        {
            path: '/content/add_institute_pic',
            component: resolve => require(['@/page/content/add_institute_pic.vue'], resolve),
        },
        {
            path: '/business/idea_list',
            component: resolve => require(['@/page/business/idea_list.vue'], resolve),
        },
        {
            path: '/business/add_idea_list',
            component: resolve => require(['@/page/business/add_idea_list.vue'], resolve),
        },
        {
            path: '/content/team_text',
            component: resolve => require(['@/page/content/team_text.vue'], resolve),
        },
        {
            path: '/content/statement',
            component: resolve => require(['@/page/content/statement.vue'], resolve),
        },
        {
            path: '/article_ja/article_list',
            component: resolve => require(['@/page/article/article_list_ja.vue'], resolve),
        },
        {
            path: '/article_ja/add_article',
            component: resolve => require(['@/page/article/add_article_ja.vue'], resolve),
        },
        {
            path: '/team_ja/team_list',
            component: resolve => require(['@/page/team/team_list_ja.vue'], resolve),
        },
        {
            path: '/team_ja/add_team',
            component: resolve => require(['@/page/team/add_team_ja.vue'], resolve),
        },
        {
            path: '/tag_ja/news',
            component: resolve => require(['@/page/tag/news_ja.vue'], resolve),
        },
        {
            path: '/tag_ja/add_news',
            component: resolve => require(['@/page/tag/add_news_ja.vue'], resolve),
        },
        {
            path: '/investment_ja/combination',
            component: resolve => require(['@/page/investment/combination_ja.vue'], resolve),
        },
        {
            path: '/investment_ja/add_combination',
            component: resolve => require(['@/page/investment/add_combination_ja.vue'], resolve),
        },
        {
            path: '/investment_ja/interview',
            component: resolve => require(['@/page/investment/interview_ja.vue'], resolve),
        },
        {
            path: '/investment_ja/add_interview',
            component: resolve => require(['@/page/investment/add_interview_ja.vue'], resolve),
        },
        {
            path: '/business_ja/report',
            component: resolve => require(['@/page/business/report_ja.vue'], resolve),
        },
        {
            path: '/business_ja/add_report',
            component: resolve => require(['@/page/business/add_report_ja.vue'], resolve),
        },
        {
            path: '/business_ja/project',
            component: resolve => require(['@/page/business/project_ja.vue'], resolve),
        },
        {
            path: '/business_ja/add_project',
            component: resolve => require(['@/page/business/add_project_ja.vue'], resolve),
        },
        {
            path: '/business_ja/practice',
            component: resolve => require(['@/page/business/practice_ja.vue'], resolve),
        },
        {
            path: '/business_ja/add_practice',
            component: resolve => require(['@/page/business/add_practice_ja.vue'], resolve),
        },
        {
            path: '/business_ja/administration',
            component: resolve => require(['@/page/business/administration_ja.vue'], resolve),
        },
        {
            path: '/business_ja/add_administration',
            component: resolve => require(['@/page/business/add_administration_ja.vue'], resolve),
        },
        {
            path: '/business_ja/idea',
            component: resolve => require(['@/page/business/idea_ja.vue'], resolve),
        },
        {
            path: '/business_ja/add_idea',
            component: resolve => require(['@/page/business/add_idea_ja.vue'], resolve),
        },
        {
            path: '/business_ja/idea_list',
            component: resolve => require(['@/page/business/idea_list_ja.vue'], resolve),
        },
        {
            path: '/business_ja/add_idea_list',
            component: resolve => require(['@/page/business/add_idea_list_ja.vue'], resolve),
        },
        {
            path: '/business_ja/team',
            component: resolve => require(['@/page/business/team_ja.vue'], resolve),
        },
        {
            path: '/business_ja/add_team',
            component: resolve => require(['@/page/business/add_team_ja.vue'], resolve),
        },
        {
            path: '/content_ja/home_page',
            component: resolve => require(['@/page/content/home_page_ja.vue'], resolve),
        },
        {
            path: '/content_ja/about',
            component: resolve => require(['@/page/content/about_ja.vue'], resolve),
        },
        {
            path: '/content_ja/society',
            component: resolve => require(['@/page/content/society_ja.vue'], resolve),
        },
        {
            path: '/content_ja/prize',
            component: resolve => require(['@/page/content/prize_ja.vue'], resolve),
        },
        {
            path: '/content_ja/add_prize',
            component: resolve => require(['@/page/content/add_prize_ja.vue'], resolve),
        },
        {
            path: '/content_ja/address',
            component: resolve => require(['@/page/content/address_ja.vue'], resolve),
        },
        {
            path: '/content_ja/add_address',
            component: resolve => require(['@/page/content/add_address_ja.vue'], resolve),
        },
        {
            path: '/content_ja/team_pic',
            component: resolve => require(['@/page/content/team_pic_ja.vue'], resolve),
        },
        {
            path: '/content_ja/add_team_pic',
            component: resolve => require(['@/page/content/add_team_pic_ja.vue'], resolve),
        },
        {
            path: '/content_ja/team_text',
            component: resolve => require(['@/page/content/team_text_ja.vue'], resolve),
        },
        {
            path: '/content_ja/agreement',
            component: resolve => require(['@/page/content/agreement_ja.vue'], resolve),
        },
        {
            path: '/content_ja/statement',
            component: resolve => require(['@/page/content/statement_ja.vue'], resolve),
        },
        {
            path: '/content_ja/institute_pic',
            component: resolve => require(['@/page/content/institute_pic_ja.vue'], resolve),
        },
        {
            path: '/content_ja/add_institute_pic',
            component: resolve => require(['@/page/content/add_institute_pic_ja.vue'], resolve),
        },
        ]
    }],
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
})



// WEBPACK FOOTER //
// ./src/router/index.js